import { InfoFilledIcon } from '@calizahq/react-components-v2'
import React from 'react'
import { Link } from 'react-router-dom'

import { Tag } from '@/components'
import { formatDate, getJobStartTime, parseDate } from '@/util'

export const JobsListColumns = [
  {
    Header: 'Job',
    accessor: (row) => row?.jobTemplate?.name,
    width: 70,
    Cell: function _Cell({ value }: any) {
      return <h3 className="whitespace-pre-wrap font-bold">{value}</h3>
    },
  },
  {
    Header: 'Home',
    accessor: (row) => `${row?.home?.searchDocument}`,
    width: 30,
    Cell: function _Cell({ value }: any) {
      return <div className="whitespace-pre-wrap font-bold">{value}</div>
    },
  },
  {
    Header: 'Date Scheduled',
    accessor: 'scheduleDate',
    width: 30,
    Cell: ({ value }: any) => {
      const scheduleDate = formatDate(parseDate(value), 'MM/dd/yyyy')
      return <div>{scheduleDate}</div>
    },
  },
  {
    Header: 'Starts At',
    accessor: 'startsAt',
    width: 30,
    Cell: ({ row, value }: any) => {
      const startsAt = getJobStartTime(value, row.original?.market?.timezone)
      return <div>{startsAt}</div>
    },
  },
  {
    Header: 'Host',
    width: 30,
    accessor: (row) => row?.host?.fullName,
    Cell: ({ value }: any) => {
      if (value) {
        return <div>{value}</div>
      }
      return <Tag variant="warning">Unclaimed</Tag>
    },
  },
  {
    Header: 'Completed',
    accessor: 'completed',
    width: 30,
    Cell: ({ value }: any) => {
      if (value) {
        return <Tag variant="success">Completed</Tag>
      }
      return null
    },
  },
  {
    accessor: 'id',
    width: 10,
    Cell: function _Cell({ value }: any) {
      return (
        <div className="ml-auto flex items-center justify-center" title="View Job">
          <Link to={`/jobs/${value}`}>
            <InfoFilledIcon className="ml-2 text-green-300" height={24} width={24} />
          </Link>
        </div>
      )
    },
  },
]
